import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/live/arthaverse-website/components/modules/industry/industryListPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["parseAsBoolean"] */ "/home/ubuntu/live/arthaverse-website/node_modules/nuqs/dist/index.js");
